<template>
  <div style="height: 100vh;width: 100%;">
    <el-col span="4" style="height: 100%;">
      <el-menu default-active="0" @select="handleSelect" style="height: 100%;width: 100%;">
        <el-menu-item index="0">
          <i class="el-icon-menu"></i>
          <span slot="title">公司新闻</span>
        </el-menu-item>
        <el-menu-item index="1">
          <i class="el-icon-menu"></i>
          <span slot="title">行业动态</span>
        </el-menu-item>
        <el-menu-item index="2">
          <i class="el-icon-menu"></i>
          <span slot="title">综合设置</span>
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col v-if="showCommonSetting" span="20" style="padding: 12px 20px;">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="图片管理" name="first">
          <el-scrollbar height="300px">
            <el-row>
              <el-col span="4">
                <el-image :src="getImageUrl('0c7a09cf22d14747aed4ed961b6ba8b2')" />
              </el-col>
              <el-col span="4">
                <el-image :src="getImageUrl('39fa35d82d554efd8bd9e3f1ede53ab6')" />
              </el-col>
            </el-row>
          </el-scrollbar>
          <!-- <el-button type="primary" @click="addPic">上传图片</el-button>" -->
        </el-tab-pane>
        <el-tab-pane label="荣誉管理" name="second">
          <el-table :data="tableData" height="250" style="width: 100%">
            <el-table-column prop="date" label="Date" width="180" />
            <el-table-column prop="name" label="Name" width="180" />
            <el-table-column prop="address" label="Address" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-col>
    <template v-else>
      <el-col v-if="!showNewsDetail" span="20" style="height: 100%;border-left: 1px solid grey;">
        <el-row style="width: 100%;height: 60px;">
          <el-col span="16" style="height: 100%;">
          </el-col>
          <el-col span="8" style="height: 60px;line-height: 60px;text-align: right;">
            <el-button style="margin-right: 40px;" type="text" @click="addNews">新增</el-button>
          </el-col>
        </el-row>
        <el-row style="width: 100%;height: calc(100% - 100px);">
          <el-table border :data="tableData" style="width: 100%;height: 100%;" height="832">
            <el-table-column prop="titleName" label="标题" width="400">
              <template slot-scope="scope">
                <div style="white-space:nowrap;text-overflow:ellipsis;overflow: hidden;">
                  {{scope.row.titleName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="发布日期" width="200" />
            <el-table-column prop="newsCover" label="封面" width="300">
              <template slot-scope="scope">
                <el-image :src="getImageUrl(scope.row.newsCover)" />
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <div style="white-space:nowrap;text-overflow:ellipsis;overflow: hidden;">
                  {{scope.row.remark}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="30">
              <template slot-scope="scope">
  <!--              <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="height: 40px;width: 100%;text-align: left;">
          <el-pagination background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]" @current-change="pageChange"
                        :current-page="pageInfo.pageNum" :page-count="pageInfo.pages" :total="pageInfo.total" />
        </el-row>
      </el-col>
      <el-col v-else span="20" style="padding-bottom: 40px;border-left: 1px solid grey;">
        <el-row style="height: 180px;margin-top: 20px;width: 100%;">
          <el-col span="1" style="height: 100%;" />
          <el-col span="14" style="height: 100%;">
            <el-row style="width: 100%;height: 40px;line-height: 40px;">
              <el-col span="16" style="text-align: left;">
                <el-col style="width: 50px;">标题:</el-col>
                <el-input v-model="titleName" style="width: calc(100% - 70px);"></el-input>
              </el-col>
              <el-col span="8" style="text-align: left;">
                <el-col style="width: 90px;">发布日期:</el-col>
                <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="createTime" style="width: calc(100% - 100px);"></el-date-picker>
              </el-col>
            </el-row>
            <el-row style="width: 100%;height: 120px;margin-top: 20px;text-align: left;line-height: 120px;">
              <el-col style="width: 50px;">备注:</el-col>
              <el-input class="remark-area" type="textarea" v-model="remark" style="height: 120px;width: calc(100% - 60px)"></el-input>
            </el-row>
          </el-col>
          <el-col span="1" style="height: 100%;" />
          <el-col span="7" style="text-align: left;height: 180px;line-height: 180px;">
            <el-col style="width: 50px;">封面</el-col>
            <el-upload
              ref="uploadCover"
              class="avatar-uploader"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="changeCoverFile">
              <img v-if="newsCoverUrl" :src="newsCoverUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
  <!--        <el-col span="1" style="height: 100%;" />-->
        </el-row>
        <el-row style="height: calc(100% - 200px);margin-top: 20px;width: 100%;">
          <el-row style="height: 50px;width: 100%;line-height: 50px;">
            <el-col span="2">
              <el-button type="text" @click="addText">添加文字</el-button>
            </el-col>
            <el-col span="2">
              <el-button type="text" @click="addImage">添加图片</el-button>
            </el-col>
            <el-col span="16" style="height: 100%;"></el-col>
            <el-col span="2">
              <el-button size="small" @click="cancel">返回</el-button>
            </el-col>
            <el-col span="2">
              <el-button type="primary" size="small" @click="publish">发布</el-button>
            </el-col>
          </el-row>
          <el-row style="height: 50px;width: 100%;">
            正文
          </el-row>
          <el-row v-for="(detail, i) in detailList" :key="i">
            <el-col v-if="detail.contentType === 0" style="margin-top: 10px;width: 60%;margin-left: 20%;">
              <el-input ref="uploadImage" type="textarea" v-model="detail.content" autosize></el-input>
            </el-col>
            <el-col v-else-if="detail.contentType === 1" style="margin-top: 10px;width: 60%;margin-left: 20%;">
              <el-upload
                ref="uploadImage"
                class="avatar-uploader"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(file, fileList) => {changeImageFile(file, fileList, i)}">
                <img v-if="detail.contentUrl" :src="detail.contentUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col style="width: 10%;display: flex;justify-content: center;">
              <el-button type="text" @click="delDetail(i)">删除</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </template>
  </div>
</template>

<script>
import { routerTo } from '../router'
import { Message } from 'element-ui'
export default {
  name: 'ManagerPage',
  data() {
    return {
      tableData: [],
      showNewsDetail: false,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        pages: 0
      },
      newsType: 0,
      titleName: '',
      remark: '',
      createTime: '',
      newsCoverUrl: '',
      newsCover: '',
      detailList: [],
      showCommonSetting: false
    }
  },
  created() {
    if (sessionStorage.getItem('token') === null) {
      routerTo(this.$router, 'LoginPage')
    } else {
      this.doQuery(1)
    }
  },
  methods: {
    doQuery(pageNum) {
      let params = {page: pageNum, rows: this.pageInfo.pageSize, newsType: this.newsType}
      this.$api.newsManage.getNewsInfo(params).then(res => {
        if (res.code !== 500) {
          this.tableData = res.data.rows
          this.pageInfo.total = res.data.total
          this.pageInfo.pageNum = res.data.pageNum
          this.pageInfo.pages = res.data.pages
        }
      })
    },
    getImageUrl(id) {
      return '/myApi/newsInfo/getImageById?id=' + id
    },
    addText() {
      let content = {contentType: 0, content: ''}
      this.detailList.push(content)
    },
    addImage() {
      let content = {contentType: 1, content: '', contentUrl: ''}
      this.detailList.push(content)
    },
    delDetail(i) {
      this.detailList.splice(i, 1)
    },
    changeCoverFile(file) {
      const isLt1M = file.size / 1024 / 1024 < 2
      if (!isLt1M) {
        Message.error('上传图片大小不能超过 2MB!')
        return
      }
      this.newsCoverUrl = URL.createObjectURL(file.raw)
      let formData = new FormData()
      formData.set('file', file.raw)
      this.$api.newsManage.uploadImage(formData).then(res => {
        if (res.code !== 500) {
          this.newsCover = res.data
        }
      })
    },
    changeImageFile(file, fileList, i) {
      const isLt1M = file.size / 1024 / 1024 < 2
      if (!isLt1M) {
        Message.error('上传图片大小不能超过 2MB!')
        return
      }
      this.detailList[i].contentUrl = URL.createObjectURL(file.raw)
      let formData = new FormData()
      formData.set('file', file.raw)
      this.$api.newsManage.uploadImage(formData).then(res => {
        if (res.code !== 500) {
          this.detailList[i].content = res.data
        }
      })
    },
    publish() {
      console.log(this.createTime)
      if (this.titleName.trim() === '') {
        Message.warning('标题未填写')
        return
      }
      if (this.createTime.trim() === '') {
        Message.warning('发布日期未填写')
        return
      }
      if (this.newsCover.trim() === '') {
        Message.warning('封面未添加')
        return
      }
      let k = 0
      this.detailList.forEach(item => {
        if (item.content.trim() !== '') {
          k = 1
        }
      })
      if (k === 0) {
        Message.warning('正文无内容')
        return
      }
      this.$confirm('确认发布当前内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {newsType: this.newsType, titleName: this.titleName.trim(), remark: this.remark.trim(), newsCover: this.newsCover,
          createTime: this.createTime, detailList: this.detailList}
        this.$api.newsManage.addNewsInfo(param).then(res => {
          if (res.code !== 500) {
            Message.success(res.message)
            this.showNewsDetail = false
            this.doQuery(1)
          }
        })
      })
    },
    cancel() {
      this.$confirm('此操作将丢弃当前填写内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showNewsDetail = false
      })
    },
    addNews() {
      this.titleName = ''
      this.remark = ''
      this.createTime = ''
      this.newsCoverUrl = ''
      this.newsCover = ''
      this.detailList = []
      this.showNewsDetail = true
    },
    handleSelect(key) {
      if (key < 2) {
        this.showCommonSetting = false;
        this.showNewsDetail = false
        this.newsType = parseInt(key)
        this.doQuery(1)
      } else {
        this.showCommonSetting = true;
      }
    },
    handleEdit() {
    },
    handleDelete(row) {
      this.$confirm('确定删除当前内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {id: row.id}
        this.$api.newsManage.deleteNewsInfo(param).then(res => {
          if (res.code !== 500) {
            Message.success(res.message)
            this.doQuery(1)
          }
        })
      })
    },
    pageChange(page) {
      this.doQuery(page)
    }
  }
}
</script>

<style>
  .remark-area .el-textarea__inner {
    height: 100% !important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 180px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 250px;
    height: 180px;
    line-height: 180px;
    text-align: center;
  }
  .avatar {
    width: 250px;
    height: 180px;
    display: block;
  }
</style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ManageNews.vue